import { Loader, Error } from '../../common'
import { ProcessButton } from '../common/detail'
import ProcessApprovalRequestForm from '../../../containers/forms/ProcessApprovalRequestForm'
import { fetchApprovalRequestDetail } from '../../../actions/approvalRequests'
import {
  selectSelectedApprovalRequest,
  getApprovalRequestProcessing,
  selectApprovalRequestType,
} from '../../../selectors/approvalRequests'
import { selectExamDateRefData } from '../../../selectors/examWindows'
import { sortColumnByKey } from '../../../utils/sort'
import { APPROVAL_REQUEST_CONFIG } from '../../../constants/ApprovalRequestConstants'
import { OrderSummary } from '.'

const mapStateToProps = state => {
  const approvalRequest = selectSelectedApprovalRequest(state)
  const arType = selectApprovalRequestType(state)
  const arId = approvalRequest[APPROVAL_REQUEST_CONFIG[arType].idField]
  const examDateRefData = selectExamDateRefData(state)

  return {
    approvalRequest,
    arId,
    arType,
    processingApprovalRequest: getApprovalRequestProcessing(state),
    examDateRefData,
  }
}

const dataBlockStyle = { marginBottom: '1em' }
const headerStyle = { fontFamily: 'Roboto,sans-serif', fontSize: '.9rem', fontWeight: 'bold' }
const valueStyle = { fontSize: '.875rem' }

const Request = ({
  approvalRequest,
  arId,
  arType,
  examDateRefData,
  processingApprovalRequest,
  fetchApprovalRequestDetail,
}) => {
  const { aiCode, orgName, orderSummary = [], fetching, error } = approvalRequest

  useEffect(() => {
    fetchApprovalRequestDetail(arId, arType)
  }, [arId])

  if (error) {
    return <Error message={error} />
  }

  if (fetching) {
    return <Loader />
  }

  return (
    <>
      <div className="row">
        <div className="col-xs-12" style={dataBlockStyle}>
          <h4 style={headerStyle}>School</h4>
          <div style={valueStyle}>
            {aiCode} <span style={{ marginLeft: '25px' }}>{orgName}</span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12" style={{ marginBottom: '1.5em' }}>
          {processingApprovalRequest ? <ProcessApprovalRequestForm /> : <ProcessButton />}
        </div>
      </div>
      <div className="row">
        <div
          className="col-xs-12"
          style={{ borderTop: '1px solid #ccc', paddingTop: '1em', marginBottom: '1.5em' }}
        >
          <h4 style={{ marginBottom: '1em' }}>Order Summary</h4>
          {examDateRefData.map((examDateType, i) => {
            if (orderSummary[examDateType]?.length) {
              return (
                <OrderSummary
                  key={examDateType}
                  items={sortColumnByKey(
                    orderSummary[examDateType],
                    ['name', 'description'],
                    ['asc', 'asc']
                  )}
                  testWindow={examDateType}
                  first={i === 0}
                />
              )
            }
          })}
        </div>
      </div>
    </>
  )
}

export default connect(mapStateToProps, { fetchApprovalRequestDetail })(Request)
